if (!customElements.get('product-form')) {
  // log("user new product form js script");
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }


      var products = []
      var drawer_option = window.custom_opt.drawer_selected
      var drawer_option_id = window.custom_opt.selected_drawer_id

      var headboard_option = window.custom_opt.headboard_selected
      var headboard_option_id = window.custom_opt.selected_headboard_id

      var fitted_sheet_option = window.custom_opt.fitted_sheet_selected
      var fitted_sheet_option_list = window.custom_opt.selected_fitted_sheets

      var mattress_option = window.custom_opt.mattress_selected
      var mattress_option_id = window.custom_opt.selected_mattress_id
      var mattress_option_qty = window.custom_opt.selected_mattress_quantity

      var extra_barrier_option = window.custom_opt.protective_barrier_selected
      var extra_barrier_option_id = window.custom_opt.selected_protective_barrier_id

      var extra_barrier_lenght_option = window.custom_opt.extra_barrier_lenght_selected
      var extra_barrier_lenght_option_id = window.custom_opt.selected_extra_barrier_lenght_id

      var extra_barrier_height_option = window.custom_opt.extra_barrier_height_selected
      var extra_barrier_height_option_id = window.custom_opt.selected_extra_barrier_height_id

      var color_option = window.custom_opt.color_option_selected
      var color_option_id = window.custom_opt.selected_color_option_id

      var height_under_bed_option = window.custom_opt.height_under_bed_selected
      var height_under_bed_option_id = window.custom_opt.selected_height_under_bed_id

      var chimney_option = window.custom_opt.chimney_selected
      var chimney_option_id = window.custom_opt.selected_chimney_id

      var climbing_wall_option = window.custom_opt.climbing_wall_selected
      var climbing_wall_option_id = window.custom_opt.selected_climbing_wall_id

      var slide_option = window.custom_opt.slide_selected
      var slide_option_id = window.custom_opt.selected_slide_id

      var staircase_position_option = window.custom_opt.staircase_position_option_selected
      var staircase_position_option_value = window.custom_opt.staircase_position_option_value

      var leg_height_option = window.custom_opt.leg_height_selected
      var leg_height_option_id = window.custom_opt.selected_leg_height_id
      var leg_height_option_value = window.custom_opt.selected_leg_height_value

      var barrier_position_option = window.custom_opt.barrier_positions_option_selected
      var barrier_position_option_value = window.custom_opt.barrier_positions_option_value

      var topper_option = window.custom_opt.topper_options_selected
      var topper_options_value = window.custom_opt.topper_options_value

      var boxspring_leg_option = window.custom_opt.boxspring_leg_options_selected
      var boxspring_leg_options_value = window.custom_opt.boxspring_leg_options_value

      var entry_position_option = window.custom_opt.entry_positions_option_selected
      var entry_position_option_value = window.custom_opt.entry_positions_option_value

      var entry_side_option = window.custom_opt.entry_side_option_selected
      var entry_side_option_value = window.custom_opt.entry_side_option_value

      var barrier_shape_option = window.custom_opt.barrier_shape_option_selected
      var barrier_shape_option_value = window.custom_opt.barrier_shape_option_value

      var mattress_for_sleepdrawer_option = window.custom_opt.mattress_for_sleepdrawer_selected
      var mattress_for_sleepdrawer_id =  window.custom_opt.selected_mattress_for_sleepdrawer_id

      // checkthis
      var product_id = window.custom_opt.product_variant_id ?? `{{ product.selected_or_first_available_variant.id }}`

      //Generate c_id (Customization id) use to indentify the cart items belonging to the same bed
      var customization_unique_id = parseInt(new Date().getTime().toString().substr(4)) + "_" + product_id;
      var product_quantity = 1;
      if (document.getElementsByClassName('quantity__input')[0]) {
        product_quantity = parseInt(document.getElementsByClassName('quantity__input')[0].value)
      }


      

      if (fitted_sheet_option == 1) {
        for (let key in fitted_sheet_option_list) {
          if (fitted_sheet_option_list[key].quantity > 0) {
            products.push(
              {
                "id": key,
                "quantity": fitted_sheet_option_list[key].quantity,
                "properties": {
                  "_c_id": customization_unique_id,
                }
              }
            )
          }

        }

      }

      if (mattress_option == 1) {
        products.push(
          {
            "id": mattress_option_id,
            "quantity": mattress_option_qty,
            "properties": {
              "_c_id": customization_unique_id,
            }
          }
        )
      }

      if (extra_barrier_option == 1) {
        products.push(
          {
            "id": extra_barrier_option_id,
            "quantity": product_quantity,
            "properties": {
              "_c_id": customization_unique_id,
            }
          }
        )
      }

      if (extra_barrier_height_option == 1) {
        products.push(
          {
            "id": extra_barrier_height_option_id,
            "quantity": product_quantity,
            "properties": {
              "_c_id": customization_unique_id,
            }
          }
        )
      }

      if (extra_barrier_lenght_option == 1) {
        products.push(
          {
            "id": extra_barrier_lenght_option_id,
            "quantity": product_quantity,
            "properties": {
              "_c_id": customization_unique_id,
            }
          }
        )
      }

      if (color_option == 1 && color_option_id != '0') {
        products.push(
          {
            "id": color_option_id,
            "quantity": product_quantity,
            "properties": {
              "_c_id": customization_unique_id,
            }
          }
        )
      }

      if (chimney_option == 1) {
        products.push(
          {
            "id": chimney_option_id,
            "quantity": product_quantity,
            "properties": {
              "_c_id": customization_unique_id,
            }
          }
        )
      }

      if (climbing_wall_option == 1) {
        products.push(
          {
            "id": climbing_wall_option_id,
            "quantity": product_quantity,
            "properties": {
              "_c_id": customization_unique_id,
            }
          }
        )
      }

      if (slide_option == 1) {
        products.push(
          {
            "id": slide_option_id,
            "quantity": product_quantity,
            "properties": {
              "_c_id": customization_unique_id,
            }
          }
        )
      }

      if (height_under_bed_option == 1) {
        products.push(
          {
            "id": height_under_bed_option_id,
            "quantity": product_quantity,
            "properties": {
              "_c_id": customization_unique_id,
            }
          }
        )
      }

      if (headboard_option == 1) {
        let headboard_color = '-';
        if (document.querySelector('#custom-selected-color')) {
          headboard_color = document.querySelector('#custom-selected-color').innerText;
        }
        if (headboard_color =='' && document.querySelector('#custom-selected-color-fabric')) {
          headboard_color = (document.querySelector('#custom-selected-color-fabric').innerText).replace(' -', '');
        }
        products.push(
          {
            "id": headboard_option_id,
            "quantity": product_quantity,
            "properties": {
              "Color": headboard_color,
              "_c_id": customization_unique_id,
            }
          }
        )
      }


      if (drawer_option == 1) {
        //Drawer -- Sleepdrawer with mattress
        if (drawer_option_id == 43644401910038) {
          //Sleepdrawer
          products.push(
            {
              "id": 46502344163668,
              "quantity": product_quantity,
              "properties": {
                "_c_id": customization_unique_id,
              }
            }
          )
          //Mattress
          products.push(
            {
              "id": 44195562422550,
              "quantity": product_quantity,
              "properties": {
                "_c_id": customization_unique_id,
              }
            }
          )
        }
        //Drawer - Guus -- Sleepdrawer + fitted mattress
        else if (drawer_option_id == 43817188491542) {
          //Sleepdrawer
          products.push(
            {
              "id": 46506153804116,
              "quantity": product_quantity,
              "properties": {
                "_c_id": customization_unique_id,
              }
            }
          )
          //Fitted mattress
          products.push(
            {
              "id": 44195565994262,
              "quantity": product_quantity,
              "properties": {
                "_c_id": customization_unique_id,
              }
            }
          )
        } else {
          products.push(
            {
              "id": drawer_option_id,
              "quantity": product_quantity,
              "properties": {
                "_c_id": customization_unique_id,
              }
            }
          )
        }
      }

      if (mattress_for_sleepdrawer_option == 1) {
        products.push(
          {
            "id": mattress_for_sleepdrawer_id,
            "quantity": product_quantity,
            "properties": {
              "_c_id": customization_unique_id,
            }
          }
        )
      }


      if (staircase_position_option == 1) {
        formData.append('properties[Staircase_position]', staircase_position_option_value)
      }

      if (drawer_option != 1) {
        if ((leg_height_option_id == "1" || leg_height_option_id == "2")) {
          formData.append('properties[Leg_height]', leg_height_option_value)
        } else if (leg_height_option == 1) {
          products.push(
            {
              "id": leg_height_option_id,
              "quantity": product_quantity,
              "properties": {
                "_c_id": customization_unique_id,
              }
            }
          )
        }
      }

      if(window.custom_opt.customizer_products && window.custom_opt.customizer_products.length){
        var customizer_products = window.custom_opt.customizer_products;
        customizer_products.sort((a, b) => b.cart_item_sort - a.cart_item_sort);
        for (let ii = 0; ii < customizer_products.length; ii++) {
          customizer_products[ii].properties._c_id = customization_unique_id;
          products.push(customizer_products[ii]);
        }
      }

      if (barrier_position_option == 1) {
        formData.append('properties[Barrier_position]', barrier_position_option_value)
      }

      if (topper_option == 1) {
        formData.append('properties[Topper]', topper_options_value)
      }

      if (boxspring_leg_option == 1) {
        formData.append('properties[Boxspring_leg_type]', boxspring_leg_options_value)
      }

      if (entry_position_option == 1) {
        formData.append('properties[Entry_position]', entry_position_option_value)
      }

      if (entry_side_option == 1) {
        formData.append('properties[Entry_side]', entry_side_option_value)
      }

      if (barrier_shape_option == 1) {
        formData.append('properties[Barrier_shape]', barrier_shape_option_value)
      }

      if (this.attributes['data-product-tags'].value.indexOf('customBed') != -1 || this.attributes['data-product-tags'].value.indexOf('expressBed') != -1) {
        formData.append('properties[_c_id]', customization_unique_id);
      } else {
        formData.append('properties[_c_id]', '');
      }

      config.body = formData;

      if (products.length > 0) {
        var formData2 = {
          'items': products
        }
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData2)
        })
        .then((response) => response.json())
        .then((data) => {
          let total = 0
          let items = []
          if (data && data.items) {
            for (let index = 0; index < data.items.length; index++) {
              const item = data.items[index];
              total += item.price*item.quantity/100
              items.push({
                item_id: item.product_id,
                item_name: item.product_title,
                affiliation: item.vendor,
                item_category:item.product_type,
                item_variant: item.variant_title,
                price: item.price/100,
                quantity: item.quantity
              })
            }
            window.dataLayer.push({
              event: "add_to_cart",
              ecommerce: {
                value: total,
                currency: "EUR",
                items: items
              }
            })
          }

          this.sendProductForm(config, products)
        })
      } else {
        this.sendProductForm(config)
      }
    }


    sendProductForm(config, products = []) {
      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push({
          event: "add_to_cart",
          ecommerce: {
            value: response.price * response.quantity/100,
            currency: "EUR",
            items: [
              {
                item_id: response.product_id,
                item_name: response.product_title,
                affiliation: response.vendor,
                item_category:response.product_type,
                item_variant: response.variant_title,
                price: response.price/100,
                quantity: response.quantity
              }
            ]
          }
        })
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');

          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
        if (products.length > 0) {
          var removeProducts = {}
          products.forEach(product => {
            removeProducts[product['id']] = 0
          })
          var formData2 = {
            'updates': removeProducts
          }
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData2)
          })
      }
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');

        if (document.querySelector('#sticky-overlay__add-to-cart-button')) {
            document.querySelector('#sticky-overlay__add-to-cart-button').classList.remove('loading');
            document.querySelector('#sticky-overlay__add-to-cart-button').removeAttribute('aria-disabled');
          }
      });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
